/**
 * Carrousel léger pour les photos d'un post.
 * - Détecte l'orientation (portrait/paysage) via width/height de la 1ère photo
 * - Portrait → conteneur 4/5 (object-fit cover, centré)
 * - Paysage → conteneur 16/10
 * - Carré → 1/1
 * - Toutes les photos du carrousel partagent le même container pour cohérence visuelle
 */
import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

function pickAspect(photos) {
  const p = photos[0];
  if (!p || !p.width || !p.height) return "16/10";
  const r = p.width / p.height;
  if (r < 0.85) return "4/5";   // portrait
  if (r > 1.15) return "16/10"; // paysage
  return "1/1";                 // carré (~)
}

export default function PhotoCarousel({ photos, aspect, testid = "photo-carousel" }) {
  const [idx, setIdx] = useState(0);
  if (!photos || photos.length === 0) return null;
  const finalAspect = aspect || pickAspect(photos);
  const photo = photos[idx];
  const prev = () => setIdx((i) => (i === 0 ? photos.length - 1 : i - 1));
  const next = () => setIdx((i) => (i === photos.length - 1 ? 0 : i + 1));

  return (
    <div
      className="relative w-full rounded-lg overflow-hidden bg-gray-50 flex items-center justify-center"
      style={{
        aspectRatio: finalAspect,
        maxHeight: "70vh", // limite portrait géant en desktop
      }}
      data-testid={testid}
    >
      <img
        src={photo.public_url}
        alt=""
        className="max-w-full max-h-full object-contain transition-opacity duration-200"
        style={{ display: "block" }}
      />
      {photos.length > 1 && (
        <>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              prev();
            }}
            data-testid={`${testid}-prev`}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 hover:bg-white flex items-center justify-center transition-colors shadow"
            aria-label="Photo précédente"
          >
            <ChevronLeft size={14} />
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              next();
            }}
            data-testid={`${testid}-next`}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/90 hover:bg-white flex items-center justify-center transition-colors shadow"
            aria-label="Photo suivante"
          >
            <ChevronRight size={14} />
          </button>
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {photos.map((_, i) => (
              <button
                key={i}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIdx(i);
                }}
                aria-label={`Photo ${i + 1}`}
                className="w-1.5 h-1.5 rounded-full transition-all"
                style={{
                  background: idx === i ? "#FFF" : "rgba(255,255,255,0.6)",
                  transform: idx === i ? "scale(1.4)" : "scale(1)",
                  boxShadow: "0 0 0 1px rgba(0,0,0,0.15)",
                }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
